/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingCustomer } from './BillingCustomer';
// @ts-ignore
import {
// @ts-ignore
    BillingCustomerFromJSON,
// @ts-ignore
    BillingCustomerFromJSONTyped,
// @ts-ignore
    BillingCustomerToJSON,
} from './BillingCustomer';
// @ts-ignore
import type { Trial } from './Trial';
// @ts-ignore
import {
// @ts-ignore
    TrialFromJSON,
// @ts-ignore
    TrialFromJSONTyped,
// @ts-ignore
    TrialToJSON,
} from './Trial';

/**
 * Request payload to update a billing subscription. The customer field is system-admin-only; when omitted, the authenticated user's billing customer is used.
 * @export
 * @interface UpdateSubscriptionRequest
 */
export interface UpdateSubscriptionRequest {
    /**
     * 
     * @type {BillingCustomer}
     * @memberof UpdateSubscriptionRequest
     */
    customer?: BillingCustomer;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    plan: UpdateSubscriptionRequestPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    billingCycle?: UpdateSubscriptionRequestBillingCycleEnum;
    /**
     * Subscription start date. System-admin-only; may be set to a past date.
     * @type {Date}
     * @memberof UpdateSubscriptionRequest
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubscriptionRequest
     */
    cancelAtPeriodEnd?: boolean;
    /**
     * 
     * @type {Trial}
     * @memberof UpdateSubscriptionRequest
     */
    trial?: Trial;
}


/**
 * @export
 */
export const UpdateSubscriptionRequestPlanEnum = {
    Free: 'free',
    Paid: 'paid'
} as const;
export type UpdateSubscriptionRequestPlanEnum = typeof UpdateSubscriptionRequestPlanEnum[keyof typeof UpdateSubscriptionRequestPlanEnum];

/**
 * @export
 */
export const UpdateSubscriptionRequestBillingCycleEnum = {
    Monthly: 'monthly'
} as const;
export type UpdateSubscriptionRequestBillingCycleEnum = typeof UpdateSubscriptionRequestBillingCycleEnum[keyof typeof UpdateSubscriptionRequestBillingCycleEnum];


/**
 * Check if a given object implements the UpdateSubscriptionRequest interface.
 */
// @ts-ignore
export function instanceOfUpdateSubscriptionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "plan" in value;

    return isInstance;
}

// @ts-ignore
export function UpdateSubscriptionRequestFromJSON(json: any): UpdateSubscriptionRequest {
    return UpdateSubscriptionRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function UpdateSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubscriptionRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customer': !exists(json, 'customer') ? undefined : BillingCustomerFromJSON(json['customer']),
        'plan': json['plan'],
        'billingCycle': !exists(json, 'billing_cycle') ? undefined : json['billing_cycle'],
        'startedAt': !exists(json, 'started_at') ? undefined : (json['started_at'] === null ? null : new Date(json['started_at'])),
        'cancelAtPeriodEnd': !exists(json, 'cancel_at_period_end') ? undefined : json['cancel_at_period_end'],
        'trial': !exists(json, 'trial') ? undefined : TrialFromJSON(json['trial']),
    };
}

// @ts-ignore
export function UpdateSubscriptionRequestToJSON(value?: UpdateSubscriptionRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customer': BillingCustomerToJSON(value.customer),
        'plan': value.plan,
        'billing_cycle': value.billingCycle,
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'cancel_at_period_end': value.cancelAtPeriodEnd,
        'trial': TrialToJSON(value.trial),
    };
}

